import { render, staticRenderFns } from "./inputTabProfil.vue?vue&type=template&id=3b7857e4"
import script from "./inputTabProfil.vue?vue&type=script&lang=js"
export * from "./inputTabProfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports